"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitedAccessAdminInviteFactory = exports.fullAccessAdminInviteFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
exports.fullAccessAdminInviteFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uuid: Factory.each(() => uuid_1.v4()),
    organization_id: mocks_1.orgClub.id,
    persona_id: mocks_1.persona.id,
    status: 'Accepted',
    permission_type: 'Full Access',
    permission_details: [],
    position_definition_ids: [2],
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    position_definitions: ['President']
});
exports.limitedAccessAdminInviteFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uuid: Factory.each(() => uuid_1.v4()),
    organization_id: mocks_1.orgClub.id,
    persona_id: mocks_1.persona.id,
    status: 'Accepted',
    permission_type: 'Limited Access',
    permission_details: ['super_reg'],
    position_definition_ids: [2],
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    position_definitions: ['Secretary']
});
